import LoadingSpinner from '../common/LoadingSpinner'

/** Shared look of the sign-in screens (same card, inputs and buttons as Login / Register) */
export const INPUT = 'w-full px-3 py-2 border border-slate-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-transparent'
export const PRIMARY_BUTTON = 'w-full bg-slate-900 text-white py-3 px-4 rounded-xl font-medium hover:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-slate-900 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed touch-manipulation shadow-lg hover:shadow-xl transition-shadow'
export const SECONDARY_BUTTON = 'w-full border border-slate-300 text-slate-900 py-3 px-4 rounded-xl font-medium hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-slate-900 focus:ring-offset-2 disabled:opacity-50 touch-manipulation'
export const LINK = 'text-slate-900 font-medium hover:underline'

export function AuthLayout({ title, subtitle, children }) {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4 safe-area-inset">
      <div className="w-full max-w-sm">
        <div className="bg-white rounded-2xl shadow-2xl p-6 sm:p-8">
          <div className="text-center mb-6">
            <h1 className="text-2xl font-bold text-slate-900">{title}</h1>
            {subtitle && <p className="text-slate-600 mt-2">{subtitle}</p>}
          </div>
          {children}
        </div>
      </div>
    </div>
  )
}

export function ErrorNote({ children }) {
  if (!children) return null
  return <div role="alert" className="mb-4 rounded-xl bg-red-50 border border-red-200 px-3 py-2 text-sm text-red-700">{children}</div>
}

export function InfoNote({ children }) {
  if (!children) return null
  return <div role="status" className="mb-4 rounded-xl bg-emerald-50 border border-emerald-200 px-3 py-2 text-sm text-emerald-900">{children}</div>
}

export function SubmitButton({ loading, busyText, children, ...props }) {
  return (
    <button type="submit" disabled={loading} className={PRIMARY_BUTTON} {...props}>
      {loading ? <span className="flex items-center justify-center gap-2"><LoadingSpinner size="sm" /> {busyText}</span> : children}
    </button>
  )
}

/** wa.me link for the business number (setting growth.whatsapp_number) */
export const whatsappLink = number => `https://wa.me/${String(number || '').replace(/\D/g, '')}`
